export default function isVideo(filename) {
	return /\.(mp4|webm|ogg)$/i.test(filename)
}
